import { Link } from 'react-router-dom'
import { publicAsset } from '../utils/publicAsset'

export function Logo({ footer = false }: { footer?: boolean }) {
  return (
    <Link className={`brand${footer ? ' brand--footer' : ''}`} to="/" aria-label="Diamond Salon home">
      <img
        className="brand__logo"
        src={publicAsset('images/Diamond-Salon-White-Logo.webp')}
        alt="Diamond Salon and Spa logo"
        width="460"
        height="125"
        decoding="async"
      />
    </Link>
  )
}
